import type { TurnAttention, TurnKind } from './presentationTypes';

export interface AttentionInput {
  kind: TurnKind;
  hasSafetyRisk: boolean;
  validationFailed: boolean;
  repairFailed: boolean;
}

/**
 * Derive the attention level for a turn presentation.
 *
 * Priority order (highest wins):
 *   critical  — safety risk or repair exhaustion
 *   required  — needs user input (clarification, approval, validation failure)
 *   optional  — recovery in progress, worth glancing at
 *   none      — plain answer or streaming status
 */
export function deriveAttention(input: AttentionInput): TurnAttention {
  if (input.hasSafetyRisk || input.repairFailed || input.kind === 'error') return 'critical';
  if (input.kind === 'clarification' || input.kind === 'review' || input.validationFailed) return 'required';
  if (input.kind === 'recovery') return 'optional';
  return 'none';
}
